module.exports = __webpack_public_path__ + "static/media/icon-menu.6c58af08.svg";